import { Modal } from 'react-bootstrap';

const LOAD_COMPLETED_MESSAGE =
  'This Load is Completed. Please contact our Customer Service Team if you wish to upload anything further.';

const LoadCompletedModal = ({ show, onHide, title = 'Load Completed', message = LOAD_COMPLETED_MESSAGE }) => {
  return (
    <Modal show={show} onHide={onHide} centered animation={false}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
      </Modal.Header>

      <Modal.Body>
        <p className="mb-0">{message}</p>
      </Modal.Body>

      <Modal.Footer
        className="d-flex flex-row py-3 px-3 gap-3 border-top bg-light justify-content-end align-items-center"
        style={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <button type="button" className="stepper-button" onClick={onHide} style={{ borderRadius: '10px' }}>
          OK
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoadCompletedModal;
